import store from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setSpellerData', function setAlteredQuery(alteredQuery, suggestedSearchTerm, suggestedSearchTermReferenceId, flaggedTokens, recourseQuery) {
    store.alteredQuery = alteredQuery;
    store.suggestedSearchTerm = suggestedSearchTerm;
    store.suggestedSearchTermReferenceId = suggestedSearchTermReferenceId;
    store.flaggedTokens = flaggedTokens;
    store.recourseQuery = recourseQuery;
});
//# sourceMappingURL=setSpellerData.js.map